<template>
  <div>
    <!-- Added preload="auto": This start loading the video immediately (if the browser agrees).
    Some mobile devices like iPhones and iPads will not preload the video in order to protect their users' bandwidth.
    This is why the value is called 'auto' and not something more final like 'true'.
    TO DO: This needs to be fix like after click on play button the browser should buffer the ample amount of video before start playing.
    This works on FireFox but have issues on Chrome  -->
      <!-- <video-player :options="videoOptions" preload="auto" ref="VideoPlayer"/> -->
      <video-player :options="videoOptions" ref="VideoPlayer"/>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css';
import videoPlayer from '../VideoPlayer.vue';
import {
  derivativeVideoURLsForVideoPlayer,
  firstThumbForEntity, entityVideoURLs,
} from '#/models/entities/entity';

// Similarly, you can also introduce the plugin resource pack you want to use within the component
// import 'some-videojs-plugin'
export default {
  components: {
    videoPlayer,
  },
  props: {
    entity: {
      required: true,
    },
  },
  data() {
    // TODO: aspect ratios and playback types
    return {
      videoOptions: {
        fluid: true,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: false,
        controls: true,
        sources: this.videoUrls(),
        poster: this.posterURL(),
      },
    };
  },
  computed: {
    player() {
      return this.$refs.VideoPlayer.player;
    },
  },
  methods: {
    posterURL() {
      return firstThumbForEntity(this.entity);
    },
    videoUrls() {
      const originalVids = entityVideoURLs([this.entity]);
      if (originalVids.length > 0) {
        console.info('using entity original vids', originalVids);
        return originalVids;
      }
      const derivativeVids = derivativeVideoURLsForVideoPlayer(this.entity);
      if (derivativeVids.length > 0) {
        console.info('using entity deriv vids', derivativeVids);
        return derivativeVids;
      }
      console.warn('entity video wrapper has no video urls to play');
      return [];
    },
    // listen event
    onPlayerPlay(player) {
    },
    onPlayerPause(player) {
    },
    // ...player event
    // or listen state event
    playerStateChanged(playerCurrentState) {
    },
    // player is ready
    playerReadied(player) {
      // you can use it to do something...
      // player.[methods]
    },
    setVideoPause() {
      this.player.pause();
    },
  },
};
</script>
